module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 306);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/radio-button");

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/radio-group");

/***/ }),

/***/ 258:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/radio-button.css");

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/radio-group.css");

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/template-preview/src/main.vue?vue&type=template&id=72916c53&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "WdDialog",
    {
      class: ["wd-template-preview", { "use-medio": _vm.useMedio }],
      attrs: {
        "append-to-body": "",
        title: _vm.confirmTitle,
        width: "900px",
        visible: _vm.confirmDialog
      },
      on: {
        "update:visible": function($event) {
          _vm.confirmDialog = $event
        },
        close: _vm.closeHandler
      }
    },
    [
      _c("div", { staticClass: "wd-content" }, [
        _c(
          "div",
          { staticClass: "radio-group" },
          [
            _c(
              "WdRadioGroup",
              {
                model: {
                  value: _vm.isMobile,
                  callback: function($$v) {
                    _vm.isMobile = $$v
                  },
                  expression: "isMobile"
                }
              },
              [
                _c("WdRadioButton", { attrs: { label: true } }, [
                  _c("span", { staticClass: "label-wrap" }, [
                    _c("img", {
                      attrs: {
                        width: "10.5px",
                        src:
                          _vm.imageUrl +
                          (_vm.isMobile ? "phone-active" : "phone") +
                          ".svg"
                      }
                    }),
                    _vm._v("手机\n                    ")
                  ])
                ]),
                _vm._v(" "),
                _c("WdRadioButton", { attrs: { label: false } }, [
                  _c("span", { staticClass: "label-wrap" }, [
                    _c("img", {
                      attrs: {
                        width: "15.5px",
                        src:
                          _vm.imageUrl +
                          (_vm.isMobile ? "pc" : "pc-active") +
                          ".svg"
                      }
                    }),
                    _vm._v("电脑\n                    ")
                  ])
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wd-content-iframe" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isMobile,
                  expression: "isMobile"
                }
              ],
              staticClass: "wd-phone-iframe"
            },
            [
              _c("div", { staticClass: "wd-phone-wrap" }, [
                _c("iframe", {
                  staticClass: "wd-preview-file",
                  attrs: {
                    id: "wd-phone-survey",
                    name: "PhoneSurvey",
                    frameborder: "0",
                    src: _vm.phonePreviewUrl,
                    scrolling: "auto"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wd-qr-code" }, [
                _c("div", { staticClass: "wd-qr-code-wrap" }, [
                  _c("p", { staticClass: "wd-qr-code-title" }, [
                    _c("span", [_vm._v("扫码预览")])
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: _vm.qrCodeUrl(), alt: "", width: "80px" }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wd-only-for-preview" })
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isMobile,
                  expression: "!isMobile"
                }
              ],
              staticClass: "wd-pc-wrap"
            },
            [
              _c("iframe", {
                staticClass: "wd-preview-file",
                attrs: {
                  id: "wd-pc-survey",
                  name: "pcSurvey",
                  frameborder: "0",
                  src: _vm.pcPreviewUrl,
                  scrolling: "auto"
                }
              })
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wd-footer", attrs: { slot: "footer" }, slot: "footer" },
        [_vm._t("footerButton")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/template-preview/src/main.vue?vue&type=template&id=72916c53&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/radio-button.css"
var radio_button_css_ = __webpack_require__(258);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/radio-button"
var radio_button_ = __webpack_require__(242);
var radio_button_default = /*#__PURE__*/__webpack_require__.n(radio_button_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/radio-group.css"
var radio_group_css_ = __webpack_require__(259);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/radio-group"
var radio_group_ = __webpack_require__(243);
var radio_group_default = /*#__PURE__*/__webpack_require__.n(radio_group_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/template-preview/src/main.vue?vue&type=script&lang=js&






/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: "TemplatePreview",
  components: {
    WdRadioGroup: radio_group_default.a,
    WdRadioButton: radio_button_default.a,
    WdDialog: dialog_default.a
  },
  props: {
    confirmTitle: {
      type: String,
      default: "模板预览"
    },
    confirmDialogShow: {
      type: Boolean,
      default: false
    },
    previewUrlCode: {
      type: String,
      default: ""
    },
    // 是否需要响应式，需要则实现小于1366 缩小15%
    useMedio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobile: true,
      confirmDialog: this.confirmDialogShow,
      phonePreviewUrl: "",
      pcPreviewUrl: "",
      imageUrl: "https://s1.wenjuan.com/assets/images/business/preview/"
    };
  },
  computed: {
    previewUrl() {
      return this.imageUrl + this.previewUrlCode;
    }
  },
  watch: {
    confirmDialogShow(newVal) {
      if (newVal) {
        this.confirmDialog = true;
      }
    },
    previewUrlCode: {
      handler(newVal) {
        console.log("previewUrlCodepreviewUrlCode");
        console.log(newVal);
        if (newVal) {
          this.phonePreviewUrl = `${window.location.origin}/s/${this.previewUrlCode}/?mobile=1&test=1&notip=1`;
          this.pcPreviewUrl = `${window.location.origin}/s/${this.previewUrlCode}/?preview=1&test=1&notip=1`;
        }
      },
      immediate: true
    }
  },
  methods: {
    clickTerminal(type) {
      this.isMobile = type === "phone";
    },
    closeHandler() {
      this.$emit("cancel", false);
    },
    qrCodeUrl() {
      return `${window.location.origin}/images/get_matrix_img?survey_url=${window.location.origin}/s/${this.previewUrlCode}/?test=1&box_size=3`;
    }
  }
});
// CONCATENATED MODULE: ./packages/template-preview/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/template-preview/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/template-preview/index.js

main.install = function (Vue) {
  Vue.component(main.name, main);
};
/* harmony default export */ var template_preview = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ })

/******/ })["default"];